export default function Hero() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Premium%20boutique%20interior%20with%20warm%20ambient%20lighting%2C%20polished%20concrete%20floors%2C%20curated%20fashion%20products%20on%20wooden%20shelves%20and%20metal%20racks%2C%20sneakers%20hoodies%20bags%20and%20accessories%20artfully%20arranged%2C%20golden%20hour%20sunlight%20streaming%20through%20large%20windows%2C%20editorial%20store%20photography%2C%20rich%20warm%20tones%2C%20luxury%20retail%20aesthetic%2C%20no%20text%2C%20high%20detail&width=1800&height=900&seq=hero-bg-kakobuy-v2&orientation=landscape"
        alt="Kakobuy Spreadsheet — Arkusz zakupowy z produktami"
        title="Kakobuy Spreadsheet — produkty w arkuszu zakupowym"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <div className="lg:max-w-[600px]">
            <div className="flex items-center gap-3 mb-6">
              <div className="flex -space-x-3">
                {['https://readdy.ai/api/search-image?query=Young%20European%20man%20with%20stylish%20haircut%20and%20confident%20smile%2C%20wearing%20a%20crew%20neck%20sweater%2C%20soft%20studio%20lighting%20against%20warm%20terracotta%20background%2C%20editorial%20portrait%20photography%2C%20natural%20skin%20texture%2C%20shallow%20depth%20of%20field&width=80&height=80&seq=avatar-v2-01&orientation=squarish', 'https://readdy.ai/api/search-image?query=Young%20European%20woman%20with%20natural%20makeup%20and%20relaxed%20expression%2C%20wearing%20a%20linen%20blouse%2C%20soft%20golden%20hour%20lighting%20against%20blush%20pink%20background%2C%20editorial%20portrait%20photography%2C%20warm%20tones%2C%20authentic%20feel&width=80&height=80&seq=avatar-v2-02&orientation=squarish', 'https://readdy.ai/api/search-image?query=Young%20European%20man%20with%20beard%20and%20friendly%20expression%2C%20wearing%20a%20denim%20jacket%2C%20soft%20window%20light%20against%20sage%20green%20background%2C%20lifestyle%20portrait%20photography%2C%20natural%20colors%2C%20relaxed%20vibe&width=80&height=80&seq=avatar-v2-03&orientation=squarish'].map((src, i) => (
                  <div key={i} className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white overflow-hidden">
                    <img src={src} alt="Zaufany użytkownik" className="w-full h-full object-cover" />
                  </div>
                ))}
              </div>
              <span className="text-white/80 text-sm font-label">Zaufane przez 10 000+ kupujących</span>
            </div>

            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
              Kakobuy<br />
              <span className="font-light">Spreadsheet</span>
            </h1>

            <p className="mt-6 text-white/80 text-base md:text-lg max-w-[480px] leading-relaxed">
              Twój kompletny arkusz zakupowy — przeglądaj kategorie, porównuj produkty i kupuj bezpiecznie. Wszystko w jednym miejscu.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white text-foreground-900 font-label font-bold text-sm rounded-full whitespace-nowrap cursor-pointer hover:bg-background-100 transition-all"
              >
                Kakobuy Sheet
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-label font-bold text-sm rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all"
              >
                Buy It Now
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shopping-bag-line"></i>
                </span>
              </a>
            </div>
          </div>

          <p className="text-white/60 text-sm lg:text-right lg:max-w-[320px] leading-relaxed">
            Odkryj 14 starannie wyselekcjonowanych kategorii produktów. Od butów po akcesoria — wszystko czego potrzebujesz, w jednym arkuszu.
          </p>
        </div>
      </div>
    </section>
  );
}